<template>
    <b-form-group :label="label" class="position-relative">
      <b-form-input
        placeholder="Ingrese contraseña"
        v-bind="$attrs"
        :type="type"
        :value="value"
        @input="updateValue"
      />
      <b-button
          @click="togglePasswordVisibility"
          variant="Light"
          class='btn-eye'
          tabindex="-1"
      >
        <b-icon v-if="showPassword" variant="primary" icon="eye-slash-fill"></b-icon>
        <b-icon v-else icon="eye-fill" variant="primary"></b-icon>
      </b-button>
    </b-form-group>
</template>

<script>
export default {
  name: 'PasswordInput',

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: 'Contraseña'
    },
    value: { 
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showPassword: false,
    };
  },

  computed: {
    type() {
      return this.showPassword ? 'text' : 'password';
    },
  },

  methods: {
    updateValue(value) {
      this.$emit('input', value);  // In Vue 2, v-model listens for 'input' event
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
.position-relative {
  position: relative
}
.btn-eye {
  padding: 0;
  border: none;
  position: absolute;
  top: 85%;
  right: 10px;
  transform: translateY(-85%);
  cursor: pointer;
}
</style>